
<ng-container *ngIf="!loaded">
  <div class="container uploader-status text-center">
    <div class="d-inline-block mt-5">
      <mat-spinner></mat-spinner>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="loaded">

  <div *ngIf="activeSubscription" class="container">

    <div class="row">
      <div class="col-md-12">
        <div class="row">
          <div class="col-12 mt-5 mb-3">
          <h4>Subscription information</h4>
          <ng-container *ngIf="!userHasActiveSubscription">
            <div>You currently do not have an active subscription!</div>
                <button  mat-flat-button
                  class="mt-3"
                  color="primary"
                  (click)="showForm()">
                <span>
                  Renew your subscription 
                </span>
              </button>
            </ng-container>
          </div>
        </div>
        <div class="">
          <table>
            <tr>


              <th>Name</th>
              <th>ZIP</th>
              <th>CC</th>
              <th>Type</th>
              <th>Price</th>
              <th  class="text-center">Next Billing Date</th>
              <th> </th>
            </tr>
            <tr *ngFor="let data of subscribtions">
              <td>{{data.firstName}} {{data.lastName}}</td>
              <td>{{data.zip}}</td>
              <td>{{data.creditCard}}</td>
              <td>{{data.type}}</td>
              <td>{{data.price}}</td>
              <td class="text-center"><ng-container *ngIf="isActive(data.status)">{{data.nextBillingDate.format("MM/DD/YYYY")}}</ng-container></td>
              <td class="text-center">
                <button *ngIf="isActive(data.status); else canceledBlock" mat-stroked-button color="warn" (click)="cancelSubscriptionDialog(data)">Cancel subscription</button>
                <ng-template #canceledBlock>
                   Canceled<div class="first"  style="font-size:12px" *ngIf="data.nextBillingDate!=null && data.subscribtionId==getFirstInactive">Valid until {{data.nextBillingDate.format("MM/DD/YYYY")}}</div>
                </ng-template>
              </td>
            </tr>
          </table>
        </div>


      </div>
    </div>
  </div>
  <div *ngIf="!activeSubscription" style="width: 100%; min-height: 50vh" class="subscription">
    <app-subscribtion (subscribeActionFinished)="subscribeFinished()" [isSubscriptionInfo]="isSubscriptionInfo"></app-subscribtion>
  </div>
</ng-container>
